import React from 'react';

export const Mobile = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#EFF6FF" />
    <g clipPath="url(#clip0_2719_2137)">
      <rect width="24" height="24" transform="translate(8 8)" fill="#EFF6FF" />
      <path d="M15 13H25V27H15V13Z" fill="#D1E3FF" />
      <path
        d="M24.99 9.01L14.99 9C13.89 9 13 9.9 13 11V29C13 30.1 13.89 31 14.99 31H24.99C26.09 31 26.99 30.1 26.99 29V11C26.99 9.9 26.09 9.01 24.99 9.01ZM24.99 27H14.99V13H24.99V27Z"
        fill="#005EE0"
      />
    </g>
    <defs>
      <clipPath id="clip0_2719_2137">
        <rect width="24" height="24" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);
